import React from "react";
import { NavLink } from "react-router-dom";

const ErrorPage = () => {
  return (
    <>
      <main className="h-screen w-full flex flex-col justify-center items-center bg-[#1A2238]">
        <h1 className="text-9xl font-extrabold text-white tracking-widest">
          404
        </h1>
        <div className="bg-purple-600 px-2 text-sm rounded rotate-12 absolute">
          Page Not Found
        </div>
        <button className="mt-5">
          <NavLink
            to="/"
            className="relative inline-block text-sm font-medium text-bg-purple-200 group active: bg-purple-600 focus:outline-none focus:ring"
          >
            <span className="absolute inset-0 transition-transform translate-x-0.5 translate-y-0.5  bg-purple-600 group-hover:translate-y-0 group-hover:translate-x-0"></span>
            <span className="relative block px-8 py-3 bg-purple-600 border border-current">
              <router-link>Go Home</router-link>
            </span>
          </NavLink>
        </button>
      </main>
    </>
  );
};

export default ErrorPage;
